import { ExternalLink, ShoppingBag } from "lucide-react";
import { JollyRoger } from "./icons/PirateIcons";

const SHOPIFY_ADMIN_URL = `https://${process.env.REACT_APP_SHOPIFY_DOMAIN}/admin/products`;

export default function EmptyShopBanner() {
    return (
        <div
            className="bounty-card p-8 lg:p-12 mb-8 relative overflow-hidden"
            data-testid="empty-shop-banner"
        >
            <div className="absolute -right-8 -top-8 opacity-10">
                <JollyRoger size={220} className="text-ink" />
            </div>
            <div className="relative max-w-2xl">
                <div className="font-hand text-2xl text-bounty">
                    lo store è quasi pronto
                </div>
                <h2 className="font-display text-4xl lg:text-5xl tracking-tight mt-2">
                    NESSUN TESORO ANCORA CARICATO
                </h2>
                <p className="mt-4 text-ink/80 leading-relaxed">
                    Il tuo negozio Shopify è connesso, ma non ha (ancora)
                    prodotti visibili. Aggiungi le tue action figures da
                    Shopify Admin: appariranno qui automaticamente in tempo
                    reale.
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                    <a
                        href={SHOPIFY_ADMIN_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-manga btn-manga-red"
                        data-testid="empty-shop-admin-link"
                    >
                        <ShoppingBag size={16} className="mr-2" />
                        Vai a Shopify Admin
                        <ExternalLink size={14} className="ml-2" />
                    </a>
                </div>
                <div className="mt-6 text-xs font-mono text-ink/60 space-y-1">
                    <div>
                        <span className="text-bounty font-bold">Suggerimento:</span>{" "}
                        aggiungi ai prodotti i tag{" "}
                        <code>category:capitano</code>,{" "}
                        <code>category:grande-rotta</code>,{" "}
                        <code>category:tesori</code>,{" "}
                        <code>category:wanted</code> per popolare le sezioni tematiche.
                    </div>
                    <div>
                        Usa il tag <code>featured</code> per metterli in
                        evidenza in home, e <code>rarity:Esclusivo</code>{" "}
                        (o Raro/Pre-ordine/Comune) per il badge di rarità.
                    </div>
                </div>
            </div>
        </div>
    );
}
